import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ACECodeEditor, Editors } from "../../../../Constants/Constants";
import CssMode from "./CssMode";
import HtmlMode from "./HtmlMode";
import JavascriptMode from "./JavascriptMode";
import PhpMode from "./PhpMode";
import { Fragment } from "react/jsx-runtime";

const AceCodeEditorContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ACECodeEditor} parent={Editors} />
      <Container fluid>
        <Row>
          <JavascriptMode />
          <HtmlMode />
          <CssMode />
          <PhpMode />
        </Row>
      </Container>
    </Fragment>
  );
};
export default AceCodeEditorContainer;
